/* 同一セクション内を1枚ずつ送るモーダル（横並びカードの中身／画像＋説明の拡大）。
   開いた要素のスライドから始まり、矢印/スワイプ/左右キーで隣へ送る（端で止まる）。
   開始位置は opener の data-slide-index。商品ギャラリー(product-modal.js)と同じ Swiper 設定。 */
if (!customElements.get('slide-modal')) {
  customElements.define(
    'slide-modal',
    class SlideModal extends ModalDialog {
      constructor() {
        super();

        this.slider = this.querySelector('.swiper');
        this.slides = this.querySelectorAll('.swiper-slide');
        this.prevButton = this.querySelector('.modalPrev');
        this.nextButton = this.querySelector('.modalNext');

        if (this.slides.length <= 1) {
          this.prevButton.hidden = true;
          this.nextButton.hidden = true;
        }

        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.swiper?.slidePrev();
          if (event.code === 'ArrowRight') this.swiper?.slideNext();
        });

        this.slider.querySelectorAll('img').forEach((img) => {
          img.addEventListener('dragstart', (event) => event.preventDefault());
        });

        // 画像だけのスライドを Swiper のズーム機構に渡す（ダブルタップとピンチ）。
        // 説明つきは figure が .scrollWrap の中なので、この直下指定から自然に外れる
        this.zoomTargets = this.slider.querySelectorAll('.swiper-slide > figure');
        this.zoomTargets.forEach((figure) => figure.classList.add('swiper-zoom-container'));

        this.initSwipeToDismiss();
      }


      show(opener) {
        super.show(opener);

        if (!this.swiper && typeof Swiper !== 'undefined') {
          const options = {
            slidesPerView: 1,
            speed: 400,
            simulateTouch: true,
            grabCursor: true,
            threshold: 5,
            resistanceRatio: 0.85,
            navigation: {
              prevEl: this.prevButton,
              nextEl: this.nextButton,
            },
          };
          if (this.zoomTargets.length) options.zoom = { enabled: true, maxRatio: 3 };
          this.swiper = new Swiper(this.slider, options);
        }

        if (!this.swiper) return;

        // 閉じている間は表示から外れて幅が 0 になるので、開くたびに測り直す
        this.swiper.update();

        const index = parseInt(this.openedBy?.getAttribute('data-slide-index'), 10);
        if (isNaN(index)) return;
        this.swiper.slideTo(index, 0);
      }
    }
  );
}
